module.exports = __webpack_public_path__ + "img/jameson-pop-up.0010be20.svg";